import {post} from "../functions";
import {questionModal} from "./modal";
import {toast} from "./toast";
import {standardResponse} from "../messages";

let ajaxListData = [];
const ajaxListOpenRows = new Set();
let ajaxListTemplate = [];
export let ajaxListPayload = [];

//Initialize AJAX tables
document.querySelectorAll('div.ajax-list').forEach(listContainer => {
    const listName = listContainer.dataset.api;
    const template = document.querySelector(`template[data-api="${listName}"]`);
    const columnNumber = template.content.querySelectorAll('.data-bar span').length;
    listContainer.style.setProperty('--column-number', columnNumber);
    ajaxListData[listName] = [];
    ajaxListTemplate[listName] = document.querySelector(`template[data-api="${listName}"]`).innerHTML;
    load(listName);
})

function getApiUrl(listName) {
    return 'api' + '/' + listName;
}

//Load AJAX data
function load(listName) {
    let filterForm = document.querySelector(`form.ajax-list-filter[data-api="${listName}"]`);
    if (!filterForm) filterForm = {};
    const apiUrl = getApiUrl(listName);
    const listContainer = document.querySelector(`div.ajax-list[data-api="${listName}"]`);

    post(apiUrl, filterForm).then(resp => {
        console.log(resp);
        if (resp.status === '0') {
            listContainer.classList.add('empty');
            listContainer.innerHTML = '<div class="empty-list">Nincs elérhető adat.</div>';
        } else {
            ajaxListPayload[listName] = resp.payload;
            listContainer.classList.remove('empty');
            ajaxListData[listName] = resp.payload.list;
            listContainer.innerHTML = '';
            Object.entries(resp.payload.list).forEach(([id, item]) => {
                const template = ajaxListTemplate[listName];
                const rowHtml = template.replace(/\{\{(\w+)\}\}/g, (match, key) => item.data[key] || '');
                const newTemplate = document.createElement('template');
                newTemplate.innerHTML = rowHtml.trim();
                const row = newTemplate.content.firstElementChild;

                //Check if row was open before reload
                if (ajaxListOpenRows.has(item.data.id)) {
                    row.addClass('open');
                }

                //Open/close row on click and add/remove from open rows set
                row.addEventListener('click', () => {
                    row.classList.toggle('open');
                    if (row.hasClass('open')) {
                        ajaxListOpenRows.add(item.data.id);
                    } else {
                        ajaxListOpenRows.delete(item.data.id);
                    }
                })
                listContainer.append(row);

                //Hide inaccessible actions
                row.querySelectorAll('.action-bar .action:not(.fix)').forEach(actionElement => {
                    const action = actionElement.dataset.action;

                    if (item.action?.includes(action)) {
                        actionElement.classList.remove('hidden');
                    } else {
                        actionElement.classList.add('hidden');
                    }
                })

                //Bind action bar functions
                row.querySelectorAll('.action-bar .action:not(.hidden)').forEach(actionElement => {
                    actionElement.addEventListener('click', (e) => {
                        e.stopPropagation();
                        const action = actionElement.dataset.action;
                        const actionType = actionElement.dataset.actionType;
                        const actionTarget = actionElement.dataset.actionTarget;
                        const actionQuestion = actionElement.dataset.question;
                        const actionModal = actionElement.dataset.actionModal;
                        const modal = document.querySelector(`dialog[data-name="${actionModal}"]`);

                        const event = new CustomEvent('ajaxListAction', {
                            bubbles: false,
                            detail: {list: listName, action: action, target: actionTarget, id: item.data.id}
                        });
                        document.dispatchEvent(event);

                        switch (actionType) {
                            case 'ajax':
                                actionAjax(actionTarget, action, item.data.id, listName);
                                break;
                            case 'ajax-confirm':
                                questionModal('Megerősítés', actionQuestion, 'error', 'Megerősítem', 'Mégsem').then(confirmation => {
                                    if (confirmation) actionAjax(actionTarget, action, item.data.id, listName);
                                })
                                break;
                            case 'view-modal':
                                const body = modal.querySelector('div.body');
                                const template = modal.querySelector('template');
                                let html = template.innerHTML;

                                const resultHtml = html.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, key) => {
                                    return item.data[key] !== undefined ? item.data[key] : '';
                                });

                                body.innerHTML = resultHtml;
                                modal.showModal();
                                break
                            case 'edit-modal':
                                modal.querySelectorAll('input, select').forEach((input) => {
                                    const property = input.name;
                                    const value = item.data[property];
                                    if (typeof value !== 'undefined') input.value = value;
                                    if (input.hasClass('trigger')) input.trigger('change');
                                })
                                modal.showModal();
                                break;
                            case 'ajax-data-modal':
                                actionAjaxDataModal(actionTarget, item.data.id, actionModal);
                                break;
                        }
                    })
                })
            })
        }
    })
}

function actionAjax(api, action, id, listName) {
    post('api/' + api, {action: action, id: id}).then(resp => {
        console.log(resp);
        if (resp.status === '200') {
            load(listName);
            standardResponse('200');
        } else if (resp.status === '400') {
            standardResponse('002', resp.payload.message);
        } else {
            standardResponse('500');
        }
    })
}

async function actionAjaxDataModal(api, id, modalName) {
    const modal = document.querySelector(`dialog[data-name="${modalName}"]`);
    const modalBody = modal.querySelector('.body');
    const template = modal.querySelector('template').innerHTML;

    modalBody.innerHTML = '';

    const resp = await post('api/' + api, {id: id});
    console.log(resp);

    Object.entries(resp.payload).forEach(([key, value]) => {
        const html = template.replace(/\{\{(\w+)\}\}/g, (match, key) => value[key] || '');
        const newTemplate = document.createElement('template');
        newTemplate.innerHTML = html.trim();
        const row = newTemplate.content.firstElementChild;

        if (Object.keys(value.data).length) {
            const ul = document.createElement('ul');
            Object.entries(value.data).forEach(([changeKey, changeValue]) => {
                const li = document.createElement('li');
                li.innerHTML = changeValue;
                ul.appendChild(li);
            });
            row.append(ul);
        }

        modalBody.append(row);
    });
    modal.showModal();
}

document.querySelectorAll('form.ajax-list-filter').forEach(form => {
    const listName = form.dataset.api;
    form.addEventListener('change', () => {
        load(listName);
    })
})

document.querySelectorAll('.ajax-list-new-modal, .ajax-list-edit-modal').forEach(modal => {
    const form = modal.querySelector('form');
    const api = modal.dataset.api;
    const listName = modal.dataset.list;


    form.addEventListener('submit', () => {
        if (form.validateForm()) {
            post('api/' + api, form).then(resp => {
                console.log(resp);
                if (resp.status === '200') {
                    load(listName);
                    modal.close();
                }

                standardResponse(resp.status, resp.payload.message || '');
            })
        } else {
            standardResponse('000');
        }
    })
})